import _get from 'lodash.get';

export default function isAssetMissing(asset) {
  const { assetFiles } = asset || {};

  return assetFiles && _get(assetFiles, 'ORIGINAL.status') === 'MISSING';
}